import { render } from "./IconChevronLeftSmall.vue?vue&type=template&id=0e4c31f4"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconChevronLeftSmall.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0e4c31f4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0e4c31f4', __exports__)) {
    api.reload('0e4c31f4', __exports__)
  }
  
  module.hot.accept("./IconChevronLeftSmall.vue?vue&type=template&id=0e4c31f4", () => {
    api.rerender('0e4c31f4', render)
  })

}


export default __exports__